module.exports = __webpack_public_path__ + "static/media/3new.2091ccb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/3new.svg
// module id = 231
// module chunks = 1